module.exports = __webpack_public_path__ + "img/Black-Panther-bg.ac8af21f.png";